import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
declare var manifestDetails: any;
declare var findIcon: any;

@Component({
    selector: 'app-pwa-alert',
    templateUrl: './app-alert.component.html',
    styleUrls: ['./app-alert.component.scss'],
    standalone: false
})
export class AppAlertComponent implements OnInit {
  public data:any;
  public alerts:any = {};
  public manifestDetails:any = {};
  public config:any = {};
  constructor(
    private _bsModalRef: BsModalRef,
  ) {    
    this.alerts[2] = "Please open Chrome and then click install App.";
    this.alerts[3] = "Please click the share button and the click 'Add to Home Screen' ";
    this.alerts[4] = "Please open Safari and then click install App.";
    this.manifestDetails = manifestDetails;
    this.config.icon = findIcon(manifestDetails.icons,'72x72');
    this.config.icon =  this.config.icon == undefined?{src:'/assets/images/pwa/72x72.png'}:this.config.icon;
    this.config.name = manifestDetails.name != undefined ? manifestDetails.name: 'KAREXPERT';
  }
  closePrompt(){
    this._bsModalRef.hide();
  }
  ngOnInit() {
  }


}
